import { TellescopeModelFromName } from "../../mappings";
import { QueryDataForMethod } from "../../types";

export const threadIsNewerThanOldest = <
  T extends Pick<TellescopeModelFromName<"inbox_threads">, "timestamp" | "outboundTimestamp">,
>(
  data: QueryDataForMethod<"inbox_threads", "load_threads"> | undefined,
  thread: T
): boolean => {
  const oldestThread = data?.pages.at(-1)?.threads.at(-1);
  if (!oldestThread) return true;
  const oldestTimestamp = oldestThread?.timestamp.getTime() ?? Infinity;
  const oldestOutboundTimestamp = (oldestThread?.outboundTimestamp || undefined)?.getTime() ?? Infinity;
  const threadTimestamp = thread.timestamp.getTime();
  const threadOutboundTimestamp = (thread.outboundTimestamp || undefined)?.getTime() ?? 0;

  return oldestTimestamp <= threadTimestamp || oldestOutboundTimestamp <= threadOutboundTimestamp;
};
